const myProgramLinks = [
  {
    id: 'checklists',
    link: '#',
    title: 'Checklists',
  },
  {
    id: 'monarchTransfermation',
    link: 'https://transfer2.odu.edu/#/',
    title: 'Monarch TRANSFERmation',
    target: '_blank',
    rel: 'noreferrer',
    tooltipTitle: 'Opens in new window',
  },
  {
    id: 'academicTranscripts',
    link: 'https://studentssb-prod.ec.odu.edu/StudentSelfService/ssb/academicTranscript',
    title: 'Academic Transcripts',
    target: '_blank',
    rel: 'noreferrer',
    tooltipTitle: 'Opens in new window',
  },
];

export default myProgramLinks;
